import React from "react";
import { CardBody, CardTitle } from "reactstrap";
import { RoundedCard } from "../layout/RoundedCard";
import { Brand } from "../layout/header/Brand";
import { HERDPLAN_APP } from "../constants";
import { trackButtonClick } from "../application-insights-config";

export const RegisterCallToAction = () => {
  return (
    <>
      <RoundedCard className="masonry-item" id="register-cta-card" highlight>
        <CardTitle className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Register Today!</h5>
          <Brand iconOnly whiteIcon />
        </CardTitle>
        <CardBody>
          <a
            onClick={() => trackButtonClick("enter_registration")}
            href={`${HERDPLAN_APP}account/register?ref=forecast`}
            target="_blank"
          >
            <strong>Register with HerdPlan today</strong>
          </a>{" "}
          and discover how <strong>managing livestock health risk</strong>{" "}
          through health planning and veterinary advice can{" "}
          <strong>benefit your business</strong>.
        </CardBody>
      </RoundedCard>
    </>
  );
};
